import React from 'react'
import './ExternalButton.scss';

function ExternalButton(props) {
    const toLink=(url)=>{
        window.open(url,"_blank");
    }
    return (
        <div className='external-button' onClick={()=>{toLink(props.url)}}>
            {props.children}
        </div>
    )
}

export default ExternalButton